export type Operator = {
  id: number;
  avatarUrl: string;
  workPosition: string;
};

export function isOnline(operator: Operator, onlineOperators: Operator[]): boolean {
  return onlineOperators.map((o) => o.id).includes(operator.id);
}
